/* eslint-disable no-param-reassign */
import _ from 'lodash';
// eslint-disable-next-line object-curly-newline
import { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { formActions } from '../../../Actions';
import { useAuth } from '../../../Components/Auth/Login/auth';
import ProductDetails from '../../../Components/Forms/Products/ProductDetails';
import ProductTags from '../../../Components/Forms/ProductTags/ProductTags';
import { ViewPageHeader } from '../../../Components/Headers';
import {
	StyledTabs,
	StyledTab,
	TabPanel,
} from '../../../Components/StyledTabs';
import { history, isEmpty } from '../../../Helpers';
import productConfig from './allproduct.config';

const TABS = ['PRODUCT DETAILS'];

const ProductViewPage = (props) => {
	const { appConfig = {} } = useAuth();
	const { measurement } = appConfig?.configs ?? {};
	const {
		fetchProduct,
		data,
		deleteProduct,
		breadcrumbs,
		subCategoriesList,
		fetchSubCategories,
	} = props;

	const [state, setState] = useState({
		activeTab: 0,
		fields: _.cloneDeep(productConfig.initialState.fields),
	});
	const { id } = useRouteMatch().params;

	useEffect(() => {
		fetchProduct({
			entity: 'ALL_PRODUCTS',
			req: {
				params: {
					id,
				},
			},
			method: 'VIEW',
		});
	}, []);

	useEffect(() => {
		if (!isEmpty(data)) {
			setState(
				productConfig.serializer(state, {
					...data,
					measurement,
					densityUnit: measurement === 'US' ? 'Lb' : 'Kg',
				})
			);
		}
	}, [data]);

	useEffect(() => {
		if (state?.fields?.category) {
			fetchSubCategories({
				entity: 'PRODUCT_SUB_CATEGORY',
				req: {
					params: {
						categoryId: state?.fields?.category,
					},
				},
				method: 'LIST',
			});
		}
	}, [state?.fields?.category]);

	const { activeTab, fields } = state;

	const handleTabChange = (event, tab) => {
		setState({
			...state,
			activeTab: tab,
		});
	};

	const excludedFields = useMemo(() => {
		let exclude = {};
		const productUnit = state?.fields?.productUnits?.reduce(
			(finalUnit, currUnit) => {
				if (currUnit?.isApplied) {
					return currUnit?.id;
				}
				return finalUnit;
			},
			''
		);

		if (
			productUnit === 'litre' ||
			productUnit === 'ml' ||
			productUnit === 'floz'
		) {
			exclude = {};
		} else {
			exclude.productDensity = true;
		}
		return exclude;
	}, [state?.fields?.productUnits]);

	const renderInfo = (idx) => {
		switch (idx) {
			case 0:
				return (
					<>
						<ProductDetails
							isDisabled
							fields={fields}
							exclude={excludedFields}
							subCategoriesList={subCategoriesList}
						/>
						<ProductTags
							fields={fields}
							menuTags={productConfig.initialState.menuTags}
							productTags={productConfig.initialState.productTags}
							isDisabled
						/>
					</>
				);
			default:
				return <></>;
		}
	};
	const { url } = useRouteMatch();

	const redirectToEdit = () => {
		const splitURL = url.split('/view');
		splitURL.splice(1, 0, '/edit');
		const newURL = splitURL.join('');
		history.push(newURL);
	};

	const handleDelete = () => {
		const splitURL = url.split('/view');
		deleteProduct({
			entity: 'ALL_PRODUCTS',
			req: {
				params: {
					id,
				},
			},
			method: 'DELETE',
		});
		history.push(splitURL[0]);
	};
	return (
		<div className='root'>
			<ViewPageHeader
				heading='View Product'
				handleEdit={redirectToEdit}
				handleDelete={handleDelete}
				breadcrumbs={[
					...breadcrumbs,
					{
						link: '',
						name: `View ${fields.name}`,
					},
				]}
				showBreadcrumbs
			/>
			<StyledTabs value={activeTab} onChange={handleTabChange}>
				{TABS.map((tab) => {
					return <StyledTab label={tab} />;
				})}
			</StyledTabs>
			{TABS.map((tab, idx) => {
				return (
					<TabPanel value={activeTab} index={idx}>
						{renderInfo(idx)}
					</TabPanel>
				);
			})}
		</div>
	);
};

const mapStateToProps = (state) => {
	const data = state.form.ALL_PRODUCTS.data.VIEW;
	const subCategoriesList = state.form.PRODUCT_SUB_CATEGORY.data.LIST;
	return {
		data,
		subCategoriesList,
	};
};

const mapDispatchToProps = {
	fetchProduct: formActions.gateway,
	deleteProduct: formActions.gateway,
	fetchSubCategories: formActions.gateway,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductViewPage);
